<template>
  <div class="mobile-modal-overlay bg-[rgba(0,0,0,0.6)] fixed inset-0 z-50 flex items-end justify-center" @click.self="$emit('close')">
    <div class="mobile-modal-sheet rounded-2xl bg-white w-full max-w-md mx-auto p-6 shadow-lg">
      <div class="text-center text-[#0033A0] text-2xl font-bold mb-4 tracking-wide ">Meeting Created</div>
      <div class="space-y-6 pt-2">
        <div class="text-center">
          <p class="text-[#0033A0] font-semibold mb-2">Meeting ID</p>
          <div class="bg-[#E8EFF5] p-3 rounded-2xl font-mono text-lg font-bold text-[#1A1A1A] tracking-widest select-all">
            {{ meetingId }}
          </div>
        </div>

        <div class="flex gap-3">
          <button @click="$emit('copy')"
            :class="isCopied ? 'bg-green-500' : 'border-2 border-[#0033A0] text-[#0033A0] hover:bg-[rgba(0,51,160,0.05)]'"
            class="flex-1 min-h-[56px] px-0 py-0 font-bold rounded-2xl transition-colors duration-150 flex items-center justify-center">
            <svg v-if="isCopied" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
            <span>{{ isCopied ? 'Copied!' : 'Copy ID' }}</span>
          </button>
          <button @click="$emit('join')"
            class="flex-1 min-h-[56px] px-4 py-3 bg-[#0033A0] text-white font-bold rounded-2xl text-lg hover:bg-[#002580] transition-colors duration-150 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            <span>Join Now</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  meetingId: {
    type: String,
    required: true
  },
  isCopied: {
    type: Boolean,
    default: false
  }
})

defineEmits(['close', 'copy', 'join'])
</script>

<style scoped>
/* .trava-logo {
  font-family: 'Zen Tokyo Zoo', sans-serif;
  letter-spacing: 0.1em;
} */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>
